export const BREAKPOINTS = {
  XS: 0,
  SM: 375,
  MD: 640,
  LG: 798,
  XL: 1024,
  XXL: 1294,
  XXXL: 1440,
}
